import {WebsiteBlackPlatformComponent} from "../WebsiteBlackPlatformComponent";
import {Resources} from "../../../../../../../resources/Resources";
import {NetworkVendor} from "../../../../../../../network/NetworkVendor";
import {Network} from "../../../../../../../network/Network";

export class WebsiteBlackPlatformHomeComponent extends WebsiteBlackPlatformComponent {
    constructor(noIntegration?: boolean) {
        super({
            title: Resources.t("words.ourPlatform"),
            description: Resources.t("words.ourPlatformDescription"),
            grid: {
                lines: [{
                    entries: [{
                        title: Resources.t("words.seoScore"),
                        description: Resources.t("words.seoScoreDescription"),
                        type: "image",
                        image: NetworkVendor.image("blog-r.webp"),
                        titleIcon: "score",
                        size: "sizeHalf",
                        linkTitle: Resources.t("words.contentEditor"),
                        linkColor: "green",
                        link: Network.router.pages.getUrlWithPath('editor')
                    }, {
                        title: Resources.t("words.contentAudit"),
                        description: Resources.t("words.contentAuditFullDescription"),
                        type: "image",
                        image: NetworkVendor.image("blog-s.webp"),
                        titleIcon: "fire",
                        size: "sizeLarge",
                        color: "colorFire",
                        linkTitle: Resources.t("words.contentAudit"),
                        linkColor: "fire",
                        link: Network.router.pages.getUrlWithPath('content-audit')
                    }]
                }, {
                    entries: [{
                        title: Resources.t("words.topics"),
                        description: Resources.t("words.topicSeoDescription"),
                        type: "image",
                        image: NetworkVendor.image("blog-t.webp"),
                        titleIcon: "topics",
                        size: "sizeLarge",
                        color: "colorBlue",
                        linkTitle: Resources.t("words.topics"),
                        linkColor: "blue",
                        link: Network.router.pages.getUrlWithPath('topics'),
                        noShadow: true
                    }, noIntegration ? {
                        title: Resources.t("words.positionTracking"),
                        description: Resources.t("words.trackContentPerformance"),
                        type: "image",
                        image: NetworkVendor.image("blog-w.webp"),
                        titleIcon: "position",
                        size: "sizeHalf",
                        shadowPosition: "shadowMid",
                        linkTitle: Resources.t("words.shopifyAnalysis"),
                        linkColor: "green",
                        link: Network.router.pages.getUrlWithPath('analysis'),
                    } : {
                        title: Resources.t("words.nativeIntegration"),
                        description: Resources.t("words.nativeIntegrationDescription"),
                        type: "icon",
                        icon: "funnel",
                        size: "sizeMidColumn",
                        color: "colorPurple",
                        shadowPosition: "shadowMid"
                    }]
                }, {
                    entries: [{
                        title: Resources.t("words.workInAnyLanguage"),
                        description: Resources.t("words.workInAnyLanguageDescription"),
                        type: "icon",
                        icon: "languages",
                        size: "sizeMid",
                        color: "colorYellow",
                        shadowPosition: "shadowBottomCenter",
                        noShadow: true
                    }, {
                        title: Resources.t("words.sedestralAi"),
                        description: Resources.t("words.sedestralAiFullDesc"),
                        type: "icon",
                        icon: "chartSedestralAi",
                        size: "sizeMid",
                        color: "colorBlue",
                        shadowPosition: "shadowLeftCenter",
                        titleIcon: "ai",
                        linkTitle: Resources.t("words.theSedestralAi"),
                        linkColor: "blue",
                        link: Network.router.pages.getUrlWithPath('ai'),
                    }]
                }]
            }
        });
    }
}